
import Livia91 from './Livia 9 (1).webp'
import Livia92 from './Livia 9 (2).webp'
import Livia93 from './Livia 9 (3).webp'
import Livia94 from './Livia 9 (4).webp'
import Livia95 from './Livia 9 (5).webp'
import Livia96 from './Livia 9 (6).webp'
import Livia97 from './Livia 9 (7).webp'
import Livia98 from './Livia 9 (8).webp'
import Livia99 from './Livia 9 (9).webp'
import Livia910 from './Livia 9 (10).webp'
import Livia911 from './Livia 9 (11).webp'
import Livia912 from './Livia 9 (12).webp'
import Livia913 from './Livia 9 (13).webp'
import Livia914 from './Livia 9 (14).webp'
import Livia915 from './Livia 9 (15).webp'

const Livia9images =[
    Livia91,Livia92,Livia93,Livia94,Livia95,Livia96,Livia97,Livia98,Livia99,Livia910,Livia911,Livia912,Livia913,Livia914,Livia915
]

export default Livia9images;